webpackJsonp([1],{

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registrationSteps_vue__ = __webpack_require__(793);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aeaa3af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registrationSteps_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registrationSteps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aeaa3af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registrationSteps_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aeaa3af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registrationSteps_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__ = __webpack_require__(794);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18610baf_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(972)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18610baf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18610baf_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18610baf_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(687)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-565437c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__ = __webpack_require__(678);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  components: {
    skSidebar: __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__["a" /* default */],
    skNavbarSidebar: __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['sidebarNavItems'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture', 'user'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('conversation', ['unreadConversations'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['token']))
});

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-sidebar'
});

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-sidebar'
});

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breadcrumb',
  props: ['items']
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(77);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_3__language_switcher__["a" /* default */],
    SkNavbarHeader: __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__["a" /* default */],
    NavHeaderLg: __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__["a" /* default */],
    NavHeaderMd: __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__["a" /* default */],
    NavHeaderSm: __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['headerMenuTree'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture'])),
  methods: {
    setLocale: function setLocale(locale) {
      __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].locale = locale;
      localStorage.setItem('locale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_item__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__ = __webpack_require__(78);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__["a" /* default */],
    NotificationItem: __WEBPACK_IMPORTED_MODULE_1__notification_item__["a" /* default */]
  },
  data: function data() {
    return {
      page: 1,
      per_page: 20
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    notifications: 'notifications/notifications',
    loading: 'notifications/loading',
    newNotifications: 'notifications/newNotifications'
  })),
  methods: {
    setSeen: function setSeen(notification) {
      if (!notification.seen_at) {
        this.$store.dispatch('notifications/seen', notification.notificationID).then(function () {
          if (notification.link) window.location.href = notification.link;
        });
      } else if (notification.link) window.location.href = notification.link;
    },
    seeAll: function seeAll() {
      var _this = this;

      this.$store.dispatch('notifications/seeAll').then(function () {
        _this.$store.dispatch('notifications/loadNotifications');

        _this.$store.dispatch('notifications/loadCounts');
      });
    },
    loadNotifications: function loadNotifications() {
      this.$store.dispatch('notifications/loadNotifications', {
        page: this.page,
        per_page: this.per_page
      });
    }
  }
});

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-item',
  props: ['item'],
  computed: {
    link: function link() {
      return this.item.link || null;
    }
  },
  methods: {
    handleClick: function handleClick($event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.$emit('seen', this.item);
    }
  }
});

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-header'
});

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(660);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-lg',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-md',
  components: {
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-sm',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  })),
  methods: {
    setLocale: function setLocale(locale) {
      this.$store.dispatch('language/setLocale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  name: 'page-title'
});

/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__ = __webpack_require__(676);
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  components: {
    NavHeader: __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__["a" /* default */]
  }
});

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_title__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breadcrumb__ = __webpack_require__(675);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-header',
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__breadcrumb__["a" /* default */],
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__page_title__["a" /* default */]
  },
  props: ['pageTitle', 'breadcrumb']
});

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(684)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a8eb91f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(663);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('tb-skeleton',{attrs:{"aspect-ratio":1,"shape":"circle"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.1}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)])])])])}
var staticRenderFns = []


/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aside',{staticClass:"col-12 col-sm-3 col-md-2 col-lg-2 position-fixed sd-bg px-sm-0 px-md-0 px-lg-1 px-xl-3 d-none d-sm-block"},[_c('div',{staticClass:"sidebar flex-nowrap overflow-auto px-0 d-flex align-items-center flex-column h-100 px-md-0 px-lg-1 px-xl-4"},[_c('div',{staticClass:"mb-auto mt-5 "},[(!_vm.user || !_vm.studentPicture)?_c('sk-sidebar'):_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"circle-border "},[_c('div',{staticClass:"circle"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":"profile-image"}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center mt-4 mb-md-5 mb-lg-0"},[_c('p',{staticClass:"f-p1 mb-2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'fullName')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'speciality')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'studentStatus')))])]),_vm._v(" "),(!_vm.sidebarNavItems || _vm.sidebarNavItems.length === 0)?_c('sk-navbar-sidebar'):_c('ul',{staticClass:"nav flex-column"},_vm._l((_vm.sidebarNavItems),function(navItem){return _c('li',{staticClass:"nav-item"},[(navItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"to":navItem.link}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()]):_c('a',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navItem.link + '&token=' + _vm.token}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()])],1)}),0)],1),_vm._v(" "),_c('div',{staticClass:" d-flex justify-content-center ug-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])],1)])])])}
var staticRenderFns = []


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(685);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("635519c8", content, true, {});

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"breadcrumb.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-container  mb-3"},[_c('nav',{attrs:{"aria-label":"breadcrumb d-none d-sm-none d-md-block"}},[_c('ol',{staticClass:"breadcrumb  ml-auto "},_vm._l((_vm.items),function(item){return _c('li',{class:['breadcrumb-item', { active: item.isActive } ]},[_c('router-link',{attrs:{"to":item.link}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1)}),0)])])}
var staticRenderFns = []


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("3cd26278", content, true, {});

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".no-notifications[data-v-565437c6]{font-weight:700;text-align:center;font-size:14px;min-height:56px}.dropdown-menu[data-v-565437c6]{padding:1.4rem 0 0;min-width:26.5rem}.dropdown-menu-items[data-v-565437c6]{max-height:300px;overflow-y:auto}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar{width:5px;height:5px}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb{background:#c2c2c2;border-radius:5px;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover{background:#c2c2c2;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track{padding-left:1rem;background:#f2f2f2;-webkit-box-shadow:inset 0 0 6px transparent;border-radius:0}", "", {"version":3,"sources":["F:/myugfront/src/components/notifications.vue"],"names":[],"mappings":"AACA,mCACE,gBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,eAAiB,CAClB,AACD,gCACE,mBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,yDACE,UAAW,AACX,UAAY,CACb,AACD,+DACE,mBAAoB,AACpB,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,qEACE,mBAAoB,AACpB,wBAA0B,CAC3B,AACD,+DACE,kBAAmB,AACnB,mBAAoB,AACpB,6CAA8C,AAC9C,eAAiB,CAClB","file":"notifications.vue","sourcesContent":["\n.no-notifications[data-v-565437c6] {\n  font-weight: bold;\n  text-align: center;\n  font-size: 14px;\n  min-height: 56px;\n}\n.dropdown-menu[data-v-565437c6] {\n  padding: 1.4rem 0 0 0;\n  min-width: 26.5rem;\n}\n.dropdown-menu-items[data-v-565437c6] {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb {\n  background: #c2c2c2;\n  border-radius: 5px;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover {\n  background: #c2c2c2;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track {\n  padding-left: 1rem;\n  background: #f2f2f2;\n  -webkit-box-shadow: inset 0 0 6px transparent;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(690)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76d7dcc1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("5ff169c0", content, true, {});

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown-item[data-v-76d7dcc1]{border-radius:0!important}.dropdown-item.unread[data-v-76d7dcc1],.dropdown-item[data-v-76d7dcc1]:hover{font-family:inherit!important;background-color:hsla(0,0%,75%,.1)}.dropdown-item .icon[data-v-76d7dcc1]{display:block;margin-right:1rem;padding:1rem}.dropdown-item .icon img[data-v-76d7dcc1]{width:36px}", "", {"version":3,"sources":["F:/myugfront/src/components/notification-item.vue"],"names":[],"mappings":"AACA,gCACE,yBAA4B,CAC7B,AACD,6EACE,8BAAgC,AAChC,kCAA2C,CAC5C,AACD,sCACE,cAAe,AACf,kBAAmB,AACnB,YAAc,CACf,AACD,0CACE,UAAY,CACb","file":"notification-item.vue","sourcesContent":["\n.dropdown-item[data-v-76d7dcc1] {\n  border-radius: 0 !important;\n}\n.dropdown-item[data-v-76d7dcc1]:hover, .dropdown-item.unread[data-v-76d7dcc1] {\n  font-family: inherit !important;\n  background-color: rgba(192, 192, 192, 0.1);\n}\n.dropdown-item .icon[data-v-76d7dcc1] {\n  display: block;\n  margin-right: 1rem;\n  padding: 1rem;\n}\n.dropdown-item .icon img[data-v-76d7dcc1] {\n  width: 36px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[{unread: !_vm.item.seen_at}, 'dropdown-item', 'd-flex'],attrs:{"href":_vm.link},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.item.icon}})]),_vm._v(" "),_c('div',[_c('div',{class:{'font-weight-bold': !_vm.item.seen_at},domProps:{"innerHTML":_vm._s(_vm.item.text)}}),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.helpers.getDateDifference(_vm.item.created_at)))])])])}
var staticRenderFns = []


/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown header-notify pl-4"},[_c('a',{staticClass:"nav-link position-relative cursor-pointer",attrs:{"data-toggle":"dropdown"},on:{"click":_vm.loadNotifications}},[(_vm.newNotifications > 0)?_c('span',[_c('span',{staticClass:"pulse"}),_vm._v(" "),_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notification-recieved.png","alt":"notifications"}})]):_c('span',[_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notifications.png","alt":"notifications"}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow animated"},[(_vm.loading)?_c('sk-list',{attrs:{"height":0.2,"items-count":4}}):_c('div',{staticClass:"dropdown-menu-items"},[(_vm.notifications.length === 0)?_c('div',{staticClass:"no-notifications"},[_vm._v("\n          "+_vm._s(_vm.$t('notifications.not-found'))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.notifications),function(notification,$index){return _c('notification-item',{key:$index,attrs:{"item":notification},on:{"seen":_vm.setSeen}})})],2),_vm._v(" "),_c('div',{staticClass:" text-center p-2 border-top"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.seeAll()}}},[_vm._v(_vm._s(_vm.$t('notifications.mark-all-as-read')))])])],1)])}
var staticRenderFns = []


/***/ }),

/***/ 694:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(697)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31e7222c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(698);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("17a670c5", content, true, {});

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown:hover>.dropdown-menu[data-v-31e7222c]{display:block}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-lg.vue"],"names":[],"mappings":"AACA,gDACE,aAAe,CAChB","file":"nav-header-lg.vue","sourcesContent":["\n.dropdown:hover>.dropdown-menu[data-v-31e7222c] {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-lg-block"},[_c('nav',{staticClass:"navbar navbar-expand-md navbar__lg  fixed-top "},[_c('div',{staticClass:"sm-w-100 d-flex order-1 order-md-2"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row align-items-center"},[_c('li',{staticClass:"nav-item d-flex align-items-center order-2 order-md-1"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item order-1 order-md-2 "},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown order-3 "},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-display":"static","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle"},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e(),_vm._v(" "),_c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse order-2 order-md-1 navbarSupportedContent",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_lg-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_lg-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")]):_c('a',{staticClass:"dropdown-item",attrs:{"href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")])],1)}),0):_vm._e()],1)}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]


/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__ = __webpack_require__(670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar__md d-none d-sm-block d-md-block d-lg-none"},[_c('nav',{staticClass:"navbar fixed-top"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"}),_vm._v(" "),_c('li',{staticClass:"nav-item d-flex align-items-center"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNavmd"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex "},[_c('ul',{staticClass:"navbar-nav mb-auto "},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect && navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mb-5"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":""}})])])}]


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__ = __webpack_require__(671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(703)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0de3b628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("6c98affe", content, true, {});

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".navbar .nav-link[data-v-0de3b628]:focus{color:#cb2026}.flag-icon[data-v-0de3b628]{width:38px;height:38px}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-sm.vue"],"names":[],"mappings":"AACA,yCACE,aAAe,CAChB,AACD,4BACE,WAAY,AACZ,WAAa,CACd","file":"nav-header-sm.vue","sourcesContent":["\n.navbar .nav-link[data-v-0de3b628]:focus{\n  color: #cb2026;\n}\n.flag-icon[data-v-0de3b628] {\n  width: 38px;\n  height: 38px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar  d-flex align-items-center navbar__sm  fixed-top  d-block d-sm-none"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNav"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex justify-content-end flex-column h-100 "},[_c('ul',{staticClass:"navbar-nav mb-auto "},[_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap"},[_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/geo.svg","alt":""},on:{"click":function($event){return _vm.setLocale('ka')}}}),_vm._v(" "),_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/eng.svg","alt":""},on:{"click":function($event){return _vm.setLocale('en')}}})])])],2),_vm._v(" "),_vm._m(3)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",staticStyle:{"height":"19px !important"},attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":"close button"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ug-logo mx-auto"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])}]


/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-header-lg',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-md',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-sm',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-center mt-5 mt-sm-0"},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []


/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(710)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e48c0c90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(713)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-211f040a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("d2b11102", content, true, {});

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"app-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header header top-header"},[_c('div',{staticClass:"container-fluid"},[_c('nav-header')],1)])}
var staticRenderFns = []


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("62111f00", content, true, {});

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"page-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"d-none d-sm-none d-md-block"},[_c('breadcrumb',{attrs:{"items":_vm.breadcrumb}})],1),_vm._v(" "),_c('div',{staticClass:"page-leftheader"},[_c('page-title',{attrs:{"title":_vm.pageTitle}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__ = __webpack_require__(678);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-sm',
  components: {
    skSidebar: __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__["a" /* default */],
    skNavbarSidebar: __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['sidebarNavItems'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture', 'user', 'token'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('conversation', ['unreadConversations']))
});

/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_sm_vue__ = __webpack_require__(717);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd36754_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_sm_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_sm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd36754_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_sm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd36754_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_sm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['width-class', 'height', 'count'],
  name: 'sk-cards'
});

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"sidebar sidebar_sm mt-4 "},[(!_vm.sidebarNavItems || _vm.sidebarNavItems.length === 0)?_c('sk-navbar-sidebar'):_c('ul',{staticClass:"nav"},_vm._l((_vm.sidebarNavItems),function(navItem){return _c('li',{staticClass:"nav-item"},[(navItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"nav-link",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"to":navItem.link}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-4 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()]):_c('a',{staticClass:"nav-link",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navItem.link + '&token=' + _vm.token}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-4 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations)+" ")]):_vm._e()])],1)}),0)],1)])])])}
var staticRenderFns = []


/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_cards_vue__ = __webpack_require__(721);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b84e5f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_cards_vue__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_cards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b84e5f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_cards_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b84e5f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_cards_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3 container",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},_vm._l((_vm.count),function(i){return _c('div',{class:'mt-2 ' + _vm.widthClass},[_c('tb-skeleton',{attrs:{"aspect-ratio":_vm.height}})],1)}),0)])}
var staticRenderFns = []


/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_sidebar__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navbar_nav_header__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(463);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    sidebar: __WEBPACK_IMPORTED_MODULE_0__components_navbar_sidebar__["a" /* default */],
    NavHeader: __WEBPACK_IMPORTED_MODULE_1__components_navbar_nav_header__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
  }
});

/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navbar_sidebar__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navbar_sidebar_sm__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_header__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_page_page_header__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_navbar_nav_header__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_page_breadcrumb__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_page_page_title__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_skeletons_sk_list__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_registration_my_subjects_modal__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_registration_must_change_subjects_modal__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_registration_minor_programs_modal__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_registration_groups_modal__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_registration_PreRegSubjects__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_registration_ChangePreRegSubject__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_skeletons_sk_cards__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_registration_WriteProblem_vue__ = __webpack_require__(992);


function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'registration',
  components: {
    SkCards: __WEBPACK_IMPORTED_MODULE_16__components_skeletons_sk_cards__["a" /* default */],
    GroupsModal: __WEBPACK_IMPORTED_MODULE_13__components_registration_groups_modal__["a" /* default */],
    MySubjectsModal: __WEBPACK_IMPORTED_MODULE_10__components_registration_my_subjects_modal__["a" /* default */],
    MustChangeSubjectsModal: __WEBPACK_IMPORTED_MODULE_11__components_registration_must_change_subjects_modal__["a" /* default */],
    SkList: __WEBPACK_IMPORTED_MODULE_9__components_skeletons_sk_list__["a" /* default */],
    PageTitle: __WEBPACK_IMPORTED_MODULE_8__components_page_page_title__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_7__components_page_breadcrumb__["a" /* default */],
    NavHeader: __WEBPACK_IMPORTED_MODULE_6__components_navbar_nav_header__["a" /* default */],
    sidebar: __WEBPACK_IMPORTED_MODULE_1__components_navbar_sidebar__["a" /* default */],
    sidebarSm: __WEBPACK_IMPORTED_MODULE_2__components_navbar_sidebar_sm__["a" /* default */],
    appHeader: __WEBPACK_IMPORTED_MODULE_3__components_app_header__["a" /* default */],
    pageHeader: __WEBPACK_IMPORTED_MODULE_4__components_page_page_header__["a" /* default */],
    MinorProgramsModal: __WEBPACK_IMPORTED_MODULE_12__components_registration_minor_programs_modal__["a" /* default */],
    breadcrumb: __WEBPACK_IMPORTED_MODULE_7__components_page_breadcrumb__["a" /* default */],
    ChangePreRegSubject: __WEBPACK_IMPORTED_MODULE_15__components_registration_ChangePreRegSubject__["a" /* default */],
    PreRegSubjects: __WEBPACK_IMPORTED_MODULE_14__components_registration_PreRegSubjects__["a" /* default */],
    WriteProblem: __WEBPACK_IMPORTED_MODULE_17__components_registration_WriteProblem_vue__["a" /* default */]
  },
  data: function data() {
    return {
      wantsChange: null,
      freeCreditSubjects: [],
      maxFreeCreditAmount: 0,
      takenFreeCreditAmount: 0,
      minorSubjects: null,
      chosenSubject: null,
      activeCollapses: [],
      isActiveFreeCreditSubjects: false,
      isActiveMinorSubjects: false,
      guideLink: '',
      isOpen: false
    };
  },
  computed: _objectSpread({
    isVisibleFreeCreditSubjects: function isVisibleFreeCreditSubjects() {
      //&& !this.user.must_choose_english
      return this.freeCreditSubjects.length > 0 || this.user.must_choose_english;
    },
    pageData: function pageData() {
      return {
        title: this.$t('registration.title'),
        breadcrumb: [{
          icon: '',
          title: this.$t('home.title'),
          link: '/',
          isActive: false
        }, {
          icon: '',
          title: this.$t('registration.title'),
          link: '/registration',
          isActive: true
        }]
      };
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])({
    user: 'auth/user',
    programModules: 'registration/programModules',
    mustChangeGroups: 'registration/mustChangeGroups',
    mustChangePreRegSubject: 'registration/mustChangePreRegSubject',
    changedPreRegSubject: 'registration/changedPreRegSubject',
    preRegSubject: 'registration/preRegSubject'
  })),
  watch: {
    user: function user() {
      if (this.user.minorProgramID !== null) {
        this.loadMinorSubjects();
      }

      this.loadRegistrationGuide();
    },
    mustChangeGroups: function mustChangeGroups(val) {
      if (val.length > 0) {
        this.$bvModal.show('must-change-subjects-modal');
      }
    },
    mustChangePreRegSubject: function mustChangePreRegSubject(val) {
      if (val) {
        this.$bvModal.show('change-pre-reg-subject');
      }
    },
    changedPreRegSubject: function changedPreRegSubject(val) {
      if (val) {
        this.chosenSubject = val;
        this.$bvModal.show('groups-modal');
      }
    },
    preRegSubject: function preRegSubject(val) {
      var _this = this;

      if (val) {
        this.chosenSubject = val;
        this.$bvModal.show('groups-modal');
        this.$store.dispatch('registration/isRegistered', {
          subjectID: val.subjectID
        }).then(function (response) {
          if (response.data.length > 0) {
            _this.$store.dispatch('registration/setsubjectChangeButtonAppear', false);
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (navigator.appVersion.indexOf("Chrome/") != -1) {
      this.root = document.documentElement;
      this.root.style.setProperty('--scroll', 'scroll');
      this.root.style.setProperty('--auto', 'auto');
    }

    this.loadModules();

    if (this.mustChangeGroups.length > 0) {
      setTimeout(function () {
        _this2.$bvModal.show('must-change-subjects-modal');
      }, 1000);
    }
  },
  methods: {
    writeProblem: function writeProblem() {
      this.$bvModal.show('write-problem-modal');
    },
    truncateValue: function truncateValue() {
      this.$store.dispatch('registration/setmustChangePreRegSubject', null);
    },
    handleClickPreRegSubjects: function handleClickPreRegSubjects() {
      this.$bvModal.show('pre-reg-modal');
    },
    showThirdButton: function showThirdButton() {
      var programIDs = [74, 76, 121, 123, 126, 128, 245, 247, 248, 258, 266, 341];
      return programIDs.indexOf(parseInt(this.user.programID)) > -1;
    },
    canChooseMinorProgram: function canChooseMinorProgram() {
      var subjects = [];

      for (var block in this.minorSubjects) {
        var _iterator = _createForOfIteratorHelper(this.minorSubjects[block]),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var s = _step.value;
            subjects.push(s);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      if (subjects.filter(function (o) {
        return o.Eval !== null;
      }).length > 0) return false;
      return this.user.ects <= 180 && this.user.studyLevel === 1;
    },
    handleSubjectChange: function handleSubjectChange(group) {
      var _this3 = this;

      this.$store.dispatch('registration/getSubject', group.subjectID).then(function (response) {
        _this3.chosenSubject = response.data.data;
        _this3.wantsChange = group.group;

        _this3.$bvModal.show('groups-modal');
      });
    },
    handleModalClose: function handleModalClose() {
      this.chosenSubject = null;
      this.wantsChange = null;
    },
    loadMinorSubjects: function loadMinorSubjects() {
      var _this4 = this;

      this.$store.dispatch('registration/loadMinorSubjects').then(function (response) {
        _this4.minorSubjects = response.data.data;
      });
    },
    loadFreeCreditSubjects: function loadFreeCreditSubjects() {
      var _this5 = this;

      this.$store.dispatch('registration/loadFreeCreditSubjects').then(function (response) {
        _this5.freeCreditSubjects = response.data.data.subjects;
        _this5.maxFreeCreditAmount = parseInt(response.data.data.max_credit_amount);
        _this5.takenFreeCreditAmount = parseInt(response.data.data.taken_credit_amount);
      });
    },
    changed: function changed() {
      this.wantsChange = null;
      this.$store.dispatch('registration/loadAlreadyRegistered');
    },
    loadModules: function loadModules() {
      var _this6 = this;

      this.$store.dispatch('registration/loadProgramModules').then(function () {
        _this6.isOpen = true;
        if (_this6.user.studyLevel == 1) _this6.loadFreeCreditSubjects();
        if (_this6.user && _this6.user.minorProgramID !== null) _this6.loadMinorSubjects();

        for (var i in _this6.activeCollapses) {
          if (_this6.activeCollapses[i]) _this6.loadSubjects(i);
        }
      });
    },
    getProgramModuleName: function getProgramModuleName(programModule) {
      if (programModule.concentrationID) {
        return this.helpers.getLocalizedField(programModule, 'program_module') + ' - ' + this.helpers.getLocalizedField(programModule, 'concentration');
      }

      return this.helpers.getLocalizedField(programModule, 'program_module');
    },
    minorProgramChanged: function minorProgramChanged(programID) {
      var _this7 = this;

      if (!programID) {
        this.minorSubjects = [];
      } else {
        this.$store.dispatch('registration/loadMinorSubjects').then(function (response) {
          _this7.minorSubjects = response.data.data;
        });
      }
    },
    check_program_module_restriction: function check_program_module_restriction(subject) {
      var _this8 = this;

      this.$store.dispatch('registration/program_module_restrictions', {
        program_moduleID: subject.program_moduleID ? subject.program_moduleID : 0
      }).then(function (response) {
        if (response.data.length > 0) {
          _this8.$swal({
            title: "",
            text: response.data[0].text,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: _this8.$t('registration.minor-modal.ok'),
            cancelButtonText: _this8.$t('registration.minor-modal.cancel'),
            closeOnConfirm: false,
            closeOnCancel: false
          }).then(function (result) {
            if (result && result.isConfirmed) {
              _this8.onSubjectClick(subject);
            } else {
              if (subject.nomeri == 'free') {
                _this8.$store.dispatch('registration/dontWantFromFreeCredit');
              }
            }
          });
        } else {
          _this8.onSubjectClick(subject);
        }
      });
    },
    onSubjectClick: function onSubjectClick(subject) {
      if (this.canRemoveTaken(subject)) {
        this.removeTaken(subject);
      } else if (!this.canRemoveTaken(subject) && this.canTake(subject) && this.isAlreadyTaken(subject)) {
        this.alreadyTaken(subject);
      } else if (!this.canRemoveTaken(subject) && this.canTake(subject)) {
        this.take(subject);
      } else {
        this.helpers.notifyMessage(this.$t('registration.subject-is-not-open'));
      }
    },
    isAlreadyTaken: function isAlreadyTaken(subject) {
      return this.canTake(subject) && subject.Eval !== null && subject.Eval !== 'F';
    },
    canRemoveTaken: function canRemoveTaken(subject) {
      return parseInt(subject.saganiID_registred) === 1;
    },
    canTake: function canTake(subject) {
      return parseInt(subject.saganiID_registredbase) === 1;
    },
    alreadyTaken: function alreadyTaken(subject) {
      var _this9 = this;

      this.$swal({
        title: "",
        text: this.$t('registration.already-taken-warning'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t('registration.minor-modal.ok'),
        cancelButtonText: this.$t('registration.minor-modal.cancel'),
        closeOnConfirm: false,
        closeOnCancel: false
      }).then(function (result) {
        if (result && result.isConfirmed) {
          _this9.take(subject);
        }
      });
    },
    take: function take(subject) {
      this.chosenSubject = subject;
      this.$bvModal.show('groups-modal');
    },
    removeTaken: function removeTaken(subject) {
      var _this10 = this;

      this.$swal({
        title: "",
        text: this.$t('registration.remove-taken-warning'),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('registration.minor-modal.ok'),
        cancelButtonText: this.$t('registration.minor-modal.cancel'),
        closeOnConfirm: false,
        closeOnCancel: false
      }).then(function (result) {
        if (result && result.isConfirmed) {
          _this10.removeTakenSubject(subject);
        }
      });
    },
    removeTakenSubject: function removeTakenSubject(subject) {
      var _this11 = this;

      this.$store.dispatch('registration/removeSubject', subject.subjectID).then(function (response) {
        _this11.helpers.notifySuccessMessage(_this11.$t('registration.messages.successfully_removed'));

        _this11.loadModules();
      });
    },
    loadSubjects: function loadSubjects(programModuleIdx) {
      this.$store.dispatch('registration/loadProgramModuleSubjects', programModuleIdx);
    },
    loadRegistrationGuide: function loadRegistrationGuide() {
      var _this12 = this;

      this.$store.dispatch('registration/loadRegistrationGuide', this.user.programID).then(function (response) {
        _this12.guideLink = response.data.data;
      });
    }
  }
});

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__ = __webpack_require__(78);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-subjects-modal',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__["a" /* default */]
  },
  computed: _objectSpread({
    totalEcts: function totalEcts() {
      return this.alreadyRegistered.reduce(function (a, b) {
        return a + parseInt(b.ECTS);
      }, 0);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    alreadyRegistered: 'registration/alreadyRegistered',
    ectsCurrentSemester: 'registration/ectsCurrentSemester'
  })),
  data: function data() {
    return {
      loading: true
    };
  },
  methods: {
    changeGroup: function changeGroup(group) {
      this.$emit('subject-change', group);
      this.$store.dispatch('registration/setsubjectChangeButtonAppear', false);
    },
    frGroup: function frGroup(group) {
      this.$emit('subject-change', group);
      this.$store.dispatch('registration/setsubjectChangeButtonAppear', false);
    },
    removeGroup: function removeGroup(group) {
      var _this = this;

      this.$store.dispatch('registration/removeSubject', group.subjectID).then(function (response) {
        _this.helpers.notifySuccessMessage(_this.$t('registration.messages.successfully_removed'));

        _this.onShown();

        _this.$emit('subject-remove');
      });
    },
    hideModal: function hideModal() {
      this.$bvModal.hide('my-subjects-modal');
    },
    sameAsNextGroup: function sameAsNextGroup(index) {
      return !this.alreadyRegistered[index + 1] || this.alreadyRegistered[index].subject === this.alreadyRegistered[index + 1].subject;
    },
    onShown: function onShown() {
      var _this2 = this;

      this.$store.dispatch('registration/loadAlreadyRegistered').then(function () {
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__ = __webpack_require__(78);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'must-change-subjects-modal',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__["a" /* default */]
  },
  computed: _objectSpread({
    totalEcts: function totalEcts() {
      return this.alreadyRegistered.reduce(function (a, b) {
        return a + parseInt(b.ECTS);
      }, 0);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    alreadyRegistered: 'registration/alreadyRegistered',
    ectsCurrentSemester: 'registration/ectsCurrentSemester',
    mustChangeGroups: 'registration/mustChangeGroups'
  })),
  data: function data() {
    return {
      loading: true
    };
  },
  methods: {
    changeGroup: function changeGroup(group) {
      this.$emit('subject-change', group);
    },
    frGroup: function frGroup(group) {
      this.$emit('subject-change', group);
    },
    removeGroup: function removeGroup(group) {
      var _this = this;

      this.$store.dispatch('registration/removeSubject', group.subjectID).then(function (response) {
        _this.helpers.notifySuccessMessage(_this.$t('registration.messages.successfully_removed'));

        _this.onShown();

        _this.$emit('subject-remove');
      });
    },
    sameAsNextGroup: function sameAsNextGroup(index) {
      return !this.alreadyRegistered[index + 1] || this.alreadyRegistered[index].subject === this.alreadyRegistered[index + 1].subject;
    },
    onShown: function onShown() {
      var _this2 = this;

      this.$store.dispatch('registration/loadAlreadyRegistered').then(function () {
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__ = __webpack_require__(78);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'minor-programs-modal',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      minorPrograms: [],
      hasChooseMinor: 0
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    user: 'auth/user'
  })),
  methods: {
    onProgramClick: function onProgramClick(program) {
      var _this = this;

      var programID = program.programID;
      if (this.user.minorProgramID === program.programID) programID = null;
      var warningText = '';
      if (this.user.minorProgramID === program.programID) warningText = this.$t('registration.minor-modal.warn-minor-change');
      if (programID === null) warningText = this.$t('registration.minor-modal.warn-minor-delete');

      if (warningText !== '') {
        this.$swal({
          title: "",
          text: warningText,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t('registration.minor-modal.ok'),
          cancelButtonText: this.$t('registration.minor-modal.cancel'),
          closeOnConfirm: false,
          closeOnCancel: false
        }).then(function (result) {
          if (result && result.isConfirmed) {
            if (programID === null && _this.hasChooseMinor == 1) {
              if (confirm(_this.$t('registration.messages.minorDeleteAlert'))) {
                _this.changeMinorProgram(programID);
              }
            } else {
              _this.changeMinorProgram(programID);
            }
          }
        });
      } else {
        if (programID === null && this.hasChooseMinor == 1) {
          if (confirm(this.$t('registration.messages.minorDeleteAlert'))) {
            this.changeMinorProgram(programID);
          }
        } else {
          this.changeMinorProgram(programID);
        }
      }
    },
    changeMinorProgram: function changeMinorProgram(programID) {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch('registration/chooseMinorPrograms', programID).then(function (response) {
        _this2.$store.dispatch('auth/user', programID);

        programID ? _this2.helpers.notifySuccessMessage(_this2.$t('registration.messages.minor_program_chosen')) : _this2.helpers.notifySuccessMessage(_this2.$t('registration.messages.minor_program_deleted'));

        _this2.$emit('change', programID);
      }).catch(function (error) {
        _this2.helpers.notifyErrorMessage(error);
      }).finally(function () {
        _this2.onShown();
      });
    },
    hideModal: function hideModal() {
      this.$bvModal.hide('minor-programs-modal');
    },
    onShown: function onShown() {
      var _this3 = this;

      this.$store.dispatch('registration/loadMinorPrograms').then(function (response) {
        _this3.loading = false;
        _this3.minorPrograms = response.data.data;
      });
      this.$store.dispatch('registration/hasChooseMinor').then(function (response) {
        _this3.hasChooseMinor = response.data;
      });
    }
  }
});

/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__groups_table__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__seminar_groups_modal__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__practise_groups_modal__ = __webpack_require__(459);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'groups-modal',
  components: {
    PractiseGroupsModal: __WEBPACK_IMPORTED_MODULE_5__practise_groups_modal__["a" /* default */],
    SeminarGroupsModal: __WEBPACK_IMPORTED_MODULE_4__seminar_groups_modal__["a" /* default */],
    GroupsTable: __WEBPACK_IMPORTED_MODULE_3__groups_table__["a" /* default */],
    SkList: __WEBPACK_IMPORTED_MODULE_2__skeletons_sk_list__["a" /* default */]
  },
  props: ['subject', 'wantsChange'],
  data: function data() {
    return {
      loading: true,
      groups: [],
      chosenGroup: null,
      chosenSeminarGroup: null,
      chosenPractiseGroup: null,
      old_subjectID: null,
      hasChooseMinor: 0,
      preRegID: 0
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    alreadyRegistered: 'registration/alreadyRegistered',
    mustChangePreRegSubject: 'registration/mustChangePreRegSubject',
    changedPreRegSubject: 'registration/changedPreRegSubject'
  })),
  watch: {
    mustChangePreRegSubject: function mustChangePreRegSubject(val) {
      var _this = this;

      if (val) {
        this.$store.dispatch('registration/getFilteredPreRegSubject', val).then(function (response) {
          _this.preRegID = response.data[0].preRegID;
        });
      }
    }
  },
  methods: {
    getSubjectProgramID: function getSubjectProgramID(subject) {
      return subject.minor_programID ? subject.minor_programID : subject.programID;
    },
    hideModal: function hideModal() {
      this.$bvModal.hide('groups-modal');
      this.$emit('closed');
      this.chosenGroup = null;
      this.chosenSeminarGroup = null;
      this.chosenPractiseGroup = null;
      this.groups = [];
      location.reload();
    },
    onShown: function onShown() {
      var _this2 = this;

      if (!this.alreadyRegistered) {
        this.$store.dispatch('registration/loadAlreadyRegistered');
      }

      this.chosenGroup = null;
      this.chosenSeminarGroup = null;
      this.chosenPractiseGroup = null;
      this.$store.dispatch('registration/getSubjectGroups', {
        subjectID: this.subject.subjectID,
        mustChangePreRegSubject: this.mustChangePreRegSubject
      }).then(function (response) {
        _this2.groups = response.data.data;
        _this2.loading = false;

        if (_this2.wantsChange) {
          var groupToChange = _this2.alreadyRegistered.find(function (o) {
            return o.group == _this2.wantsChange;
          });

          if (groupToChange.main_group) {
            var mainGroup = _this2.alreadyRegistered.find(function (o) {
              return o.group == groupToChange.main_group;
            });

            _this2.openSeminarModal(mainGroup);
          }

          if (_this2.helpers.practiseLectureIds().indexOf(parseInt(groupToChange.lecture_typeID)) > -1) {
            var _mainGroup = _this2.alreadyRegistered.find(function (o) {
              return o.subjectID == groupToChange.subjectID && !o.main_group;
            });

            _this2.openPractiseModal(_mainGroup);
          }
        }
      }).catch(function (error) {
        // this.hideModal();
        _this2.helpers.notifyErrorMessage(error);
      });
      this.$store.dispatch('registration/hasChooseMinor').then(function (response) {
        _this2.hasChooseMinor = response.data;
      });
    },
    handleGroupClick: function handleGroupClick(group) {
      var _this3 = this;

      if (!parseInt(group.has_practice) && !parseInt(group.has_seminar)) {
        this.$swal({
          title: "",
          text: this.$t('registration.confirm-registration'),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t('registration.minor-modal.ok'),
          cancelButtonText: this.$t('registration.minor-modal.cancel'),
          closeOnConfirm: false,
          closeOnCancel: false
        }).then(function (result) {
          if (result && result.isConfirmed) _this3.choose(group);
        });
      }

      if (parseInt(group.has_seminar)) this.openSeminarModal(group);
      if (!parseInt(group.has_seminar) && parseInt(group.has_practice)) this.openPractiseModal(group);
    },
    openPractiseModal: function openPractiseModal(group) {
      this.chosenGroup = group;
      this.$bvModal.show('practise-groups-modal');
    },
    openPractiseModalFromSeminar: function openPractiseModalFromSeminar(group) {
      this.chosenSeminarGroup = group;
      this.$bvModal.show('practise-groups-modal');
    },
    openSeminarModal: function openSeminarModal(group) {
      this.chosenGroup = group;
      this.$bvModal.show('seminar-groups-modal');
    },
    choose: function choose(group) {
      this.chosenGroup = group;
      if (this.wantsChange !== null) this.changeSubject();else this.register();
    },
    register: function register() {
      var _this4 = this;

      this.$store.dispatch('registration/register', {
        programModuleID: this.subject.program_moduleID,
        programID: this.getSubjectProgramID(this.subject),
        group: this.chosenGroup,
        old_subjectID: this.mustChangePreRegSubject,
        newSubjectID: this.changedPreRegSubject ? this.changedPreRegSubject.subjectID : 0,
        hasChooseMinor: this.hasChooseMinor,
        preRegID: this.preRegID
      }).then(function (response) {
        _this4.helpers.notifySuccessMessage(_this4.$t('registration.messages.successfully_registered'));

        _this4.$bvModal.hide('groups-modal');

        _this4.$emit('registered');
      }).catch(function (error) {
        _this4.helpers.notifyErrorMessage(error);
      });
    },
    choosePractise: function choosePractise(group) {
      this.chosenPractiseGroup = group;
      if (this.wantsChange !== null) this.changeSubject();else this.registerPractise();
    },
    registerPractise: function registerPractise() {
      var _this5 = this;

      this.$store.dispatch('registration/register', {
        programModuleID: this.subject.program_moduleID,
        programID: this.getSubjectProgramID(this.subject),
        group: this.chosenGroup,
        seminarGroup: this.chosenSeminarGroup,
        practiseGroup: this.chosenPractiseGroup
      }).then(function (response) {
        _this5.helpers.notifySuccessMessage(_this5.$t('registration.messages.successfully_registered'));

        _this5.$bvModal.hide('practise-groups-modal');

        _this5.$bvModal.hide('seminar-groups-modal');

        _this5.$bvModal.hide('groups-modal');

        _this5.$emit('registered');
      }).catch(function (error) {
        _this5.helpers.notifyErrorMessage(error);
      });
    },
    chooseSeminar: function chooseSeminar(group) {
      this.chosenSeminarGroup = group;
      if (this.wantsChange !== null) this.changeSubject();else this.registerSeminar();
    },
    registerSeminar: function registerSeminar() {
      var _this6 = this;

      this.$store.dispatch('registration/register', {
        programModuleID: this.subject.program_moduleID,
        programID: this.getSubjectProgramID(this.subject),
        group: this.chosenGroup,
        seminarGroup: this.chosenSeminarGroup
      }).then(function (response) {
        _this6.helpers.notifySuccessMessage(_this6.$t('registration.messages.successfully_registered'));

        _this6.$bvModal.hide('seminar-groups-modal');

        _this6.$bvModal.hide('groups-modal');

        _this6.$emit('registered');
      }).catch(function (error) {
        _this6.helpers.notifyErrorMessage(error);
      });
    },
    changeSubject: function changeSubject() {
      var _this7 = this;

      this.$store.dispatch('registration/change', {
        programModuleID: this.subject.program_moduleID,
        programID: this.getSubjectProgramID(this.subject),
        oldGroup: this.wantsChange,
        group: this.chosenGroup,
        seminarGroup: this.chosenSeminarGroup ? this.chosenSeminarGroup : null,
        practiseGroup: this.chosenPractiseGroup ? this.chosenPractiseGroup : null
      }).then(function (response) {
        _this7.helpers.notifySuccessMessage(_this7.$t('registration.messages.successfully_changed'));

        _this7.$bvModal.hide('practise-groups-modal');

        _this7.$bvModal.hide('seminar-groups-modal');

        _this7.$bvModal.hide('groups-modal');

        _this7.$emit('changed');

        _this7.chosenGroup = null;
        _this7.chosenSeminarGroup = null;
        _this7.chosenPractiseGroup = null;
      }).catch(function (error) {
        _this7.helpers.notifyErrorMessage(error);
      });
    }
  }
});

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      preRegSubjects: []
    };
  },
  methods: {
    hideModal: function hideModal() {
      this.$bvModal.hide('pre-reg-modal');
      this.$emit('closed');
      location.reload();
    },
    onShown: function onShown() {
      var _this = this;

      this.$store.dispatch('registration/getAllPreRegSubjects').then(function (response) {
        _this.preRegSubjects = response.data;
      });
    },
    handleclick: function handleclick(subject) {
      this.$store.dispatch('registration/setpreRegSubject', {
        subject: subject
      });
    }
  }
});

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      theData: []
    };
  },
  methods: {
    onShown: function onShown() {
      var _this = this;

      this.$store.dispatch('registration/getProgramSubjects').then(function (response) {
        _this.theData = response.data;
      });
    },
    hideModal: function hideModal() {
      this.$bvModal.hide('change-pre-reg-subject');
      this.$emit('closed');
    },
    changeToSubject: function changeToSubject(subjects) {
      this.$store.dispatch('registration/setChangedPreRegSubject', subjects);
      this.$bvModal.hide('change-pre-reg-subject');
      this.$bvModal.hide('groups-modal');
    }
  }
});

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      problemText: null,
      showButton: true
    };
  },
  methods: {
    sendProblem: function sendProblem() {
      var _this = this;

      if (this.problemText) {
        this.showButton = false;
        this.$store.dispatch('registration/writeProblem', this.problemText).then(function () {
          _this.helpers.notifySuccessMessage(_this.$t('registration.problemSent'));

          _this.hideModal();
        });
      } else {
        alert(this.$t('registration.alertEmpty'));
      }
    },
    onShown: function onShown() {},
    hideModal: function hideModal() {
      this.$bvModal.hide('write-problem-modal');
      this.$emit('closed');
    }
  }
});

/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('sidebar'),_vm._v(" "),_c('nav-header'),_vm._v(" "),_c('main',{staticClass:"col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10",attrs:{"role":"main"}},[_c('section',{staticClass:"px-sm-0 mx-sm-0 px-lg-5 mx-lg-5  mt-0 mt-md-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row my-5"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-content-around align-items-center",staticStyle:{"height":"50vh"}},[_c('router-link',{staticClass:"btn btn-danger w-25 p-4",staticStyle:{"font-size":"1.5rem"},attrs:{"to":"/pre-registration"}},[_vm._v(_vm._s(_vm.$t('registration.firstStep')))]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger w-25 p-4",staticStyle:{"font-size":"1.5rem"},attrs:{"to":"/registration"}},[_vm._v(_vm._s(_vm.$t('registration.secondStep')))])],1)])])])])])],1)])}
var staticRenderFns = []


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("3e9ecf8c", content, true, {});

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"registration.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_my_subjects_modal_vue__ = __webpack_require__(795);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a667676c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_my_subjects_modal_vue__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(975)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a667676c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_my_subjects_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a667676c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_my_subjects_modal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a667676c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_my_subjects_modal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("abe84782", content, true, {});

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".registration-group-table img[data-v-a667676c]{cursor:pointer}", "", {"version":3,"sources":["F:/myugfront/src/components/registration/my-subjects-modal.vue"],"names":[],"mappings":"AACA,+CACI,cAAgB,CACnB","file":"my-subjects-modal.vue","sourcesContent":["\n.registration-group-table img[data-v-a667676c] {\n    cursor: pointer;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.my-subjects-modal",modifiers:{"my-subjects-modal":true}}]},[_vm._v(_vm._s(_vm.$t('registration.already-registered-subjects')))]),_vm._v(" "),_c('b-modal',{attrs:{"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"my-subjects-modal","size":"xl","centered":""},on:{"shown":function($event){return _vm.onShown()}}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col mb-5 pb-5 "},[_c('h4',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$t('registration.my-subjects')))]),_vm._v(" "),_c('div',{staticClass:"registration-group-table"},[(_vm.loading)?_c('sk-list',{attrs:{"height":"0.02","items-count":4}}):_c('table',{staticClass:"table table-responsive-lg"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('registration.group')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.ects')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.subject')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.lecturer')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.day')))]),_vm._v(" "),_c('th',{staticClass:"min-width: 100px;"},[_vm._v(_vm._s(_vm.$t('registration.date')))]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v(_vm._s(_vm.$t('registration.time')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.room')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"36px"}},[_vm._v(" ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"36px"}},[_vm._v(" ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.alreadyRegistered),function(group,i){return _c('tr',{class:{ 'border-bottom': !_vm.sameAsNextGroup(i) }},[_c('td',[_vm._v(_vm._s(group.group))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.ECTS))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'subject')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'lectors')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'type')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'day')))]),_vm._v(" "),_c('td',[(group.start_date && group.start_date !== '')?_c('span',[_vm._v(_vm._s(group.start_date)+" "),_c('br'),_vm._v(" "+_vm._s(group.end_date))]):_c('span',[_vm._v(_vm._s(group.holddate))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.time + ' - ' + group.time_end))]),_vm._v(" "),(group.start_date && group.start_date !== '')?_c('td',[_vm._v("\n                    "+_vm._s(_vm.$t('registration.curation'))+", "+_vm._s(_vm.helpers.getLocalizedField(group, 'Rooms'))+"\n                  ")]):(group.Rooms)?_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'Rooms')))]):_c('td',[_vm._v(_vm._s(_vm.$t('registration.distance-room')))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"4rem"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/change.png"},on:{"click":function($event){return _vm.changeGroup(group)}}})]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"4rem"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/close.png"},on:{"click":function($event){return _vm.removeGroup(group)}}})])])}),0)])],1),_vm._v(" "),_c('div',{staticClass:"px-5 px-sm-0 mx-5 mx-sm-0"},[(_vm.loading)?_c('sk-list',{attrs:{"height":"0.01","items-count":1}}):_c('p',{staticClass:"warninng"},[_vm._v(_vm._s(_vm.$t('registration.total-ects'))+": "+_vm._s(_vm.ectsCurrentSemester))])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-0 pt-3 mt-sm-5 pt-sm-5 mb-3"},[_c('button',{staticClass:"btn btn-light-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModal()}}},[_vm._v(_vm._s(_vm.$t('registration.close')))])])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_must_change_subjects_modal_vue__ = __webpack_require__(796);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53defa4e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_must_change_subjects_modal_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(979)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53defa4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_must_change_subjects_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53defa4e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_must_change_subjects_modal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53defa4e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_must_change_subjects_modal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(980);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("7e93f4f4", content, true, {});

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".registration-group-table img[data-v-53defa4e]{cursor:pointer}tr.text-red td[data-v-53defa4e]{color:red!important}", "", {"version":3,"sources":["F:/myugfront/src/components/registration/must-change-subjects-modal.vue"],"names":[],"mappings":"AACA,+CACI,cAAgB,CACnB,AACD,gCACE,mBAAuB,CACxB","file":"must-change-subjects-modal.vue","sourcesContent":["\n.registration-group-table img[data-v-53defa4e] {\n    cursor: pointer;\n}\ntr.text-red td[data-v-53defa4e] {\n  color: #f00 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"hide-header":true,"hide-footer":true,"no-close-on-esc":true,"no-close-on-backdrop":true,"content-class":"modal-blue","id":"must-change-subjects-modal","size":"xl","centered":""},on:{"shown":function($event){return _vm.onShown()}}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col mb-5 pb-5 "},[_c('h4',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$t('registration.must-change-subjects')))]),_vm._v(" "),_c('div',{staticClass:"registration-group-table"},[(_vm.loading)?_c('sk-list',{attrs:{"height":"0.02","items-count":4}}):_c('table',{staticClass:"table table-responsive-lg"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('registration.group')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.ects')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.subject')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.lecturer')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.day')))]),_vm._v(" "),_c('th',{staticClass:"min-width: 100px;"},[_vm._v(_vm._s(_vm.$t('registration.date')))]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v(_vm._s(_vm.$t('registration.time')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.room')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"36px"}},[_vm._v(" ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"36px"}},[_vm._v(" ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.alreadyRegistered),function(group,i){return _c('tr',{class:[{ 'text-red': _vm.mustChangeGroups.indexOf(group.group) !== -1 }, { 'border-bottom': !_vm.sameAsNextGroup(i) }]},[_c('td',[_vm._v(_vm._s(group.group))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.ECTS))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'subject')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'lectors')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'type')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'day')))]),_vm._v(" "),_c('td',[(group.start_date && group.start_date !== '')?_c('span',[_vm._v(_vm._s(group.start_date)+" "),_c('br'),_vm._v(" "+_vm._s(group.end_date))]):_c('span',[_vm._v(_vm._s(group.holddate))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.time + ' - ' + group.time_end))]),_vm._v(" "),(group.start_date && group.start_date !== '')?_c('td',[_vm._v("\n                    "+_vm._s(_vm.$t('registration.curation'))+", "+_vm._s(_vm.helpers.getLocalizedField(group, 'Rooms'))+"\n                  ")]):(group.Rooms)?_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(group, 'Rooms')))]):_c('td',[_vm._v(_vm._s(_vm.$t('registration.distance-room')))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"4rem"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/change.png"},on:{"click":function($event){return _vm.changeGroup(group)}}})]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"4rem"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/close.png"},on:{"click":function($event){return _vm.removeGroup(group)}}})])])}),0)])],1),_vm._v(" "),_c('div',{staticClass:"px-5 px-sm-0 mx-5 mx-sm-0"},[(_vm.loading)?_c('sk-list',{attrs:{"height":"0.01","items-count":1}}):_c('p',{staticClass:"warninng"},[_vm._v(_vm._s(_vm.$t('registration.total-ects'))+": "+_vm._s(_vm.ectsCurrentSemester))])],1)])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_minor_programs_modal_vue__ = __webpack_require__(797);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da690b5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_minor_programs_modal_vue__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(983)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5da690b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_minor_programs_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da690b5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_minor_programs_modal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da690b5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_minor_programs_modal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(984);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("8e929792", content, true, {});

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".table-minor-programs tr td[data-v-5da690b5]{cursor:pointer}.table-minor-programs tr td[data-v-5da690b5]:first-of-type{border-top-left-radius:10px;border-bottom-left-radius:10px}.table-minor-programs tr td[data-v-5da690b5]:last-of-type{border-top-right-radius:10px;border-bottom-right-radius:10px}.table-minor-programs tr:hover td[data-v-5da690b5]{background-color:hsla(0,0%,100%,.3)}", "", {"version":3,"sources":["F:/myugfront/src/components/registration/minor-programs-modal.vue"],"names":[],"mappings":"AACA,6CACE,cAAgB,CACjB,AACD,2DACE,4BAA6B,AAC7B,8BAAgC,CACjC,AACD,0DACE,6BAA8B,AAC9B,+BAAiC,CAClC,AACD,mDACE,mCAA2C,CAC5C","file":"minor-programs-modal.vue","sourcesContent":["\n.table-minor-programs tr td[data-v-5da690b5] {\n  cursor: pointer;\n}\n.table-minor-programs tr td[data-v-5da690b5]:first-of-type {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n.table-minor-programs tr td[data-v-5da690b5]:last-of-type {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n.table-minor-programs tr:hover td[data-v-5da690b5] {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.minor-programs-modal",modifiers:{"minor-programs-modal":true}}]},[_vm._v(_vm._s(_vm.$t('registration.choose-minor-program')))]),_vm._v(" "),_c('b-modal',{attrs:{"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"minor-programs-modal","size":"md"},on:{"shown":function($event){return _vm.onShown()}}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col mb-5 pb-5 "},[_c('h4',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$t('registration.choose-minor-program')))]),_vm._v(" "),_c('div',{staticClass:"registration-group-table mb-0"},[(_vm.loading)?_c('sk-list',{attrs:{"height":"0.02","items-count":4}}):_c('table',{staticClass:"table w-100 table-minor-programs"},[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.program-name')))]),_vm._v(" "),_c('th',[_vm._v(" ")])]),_vm._v(" "),_vm._l((_vm.minorPrograms),function(program,i){return _c('tr',{on:{"click":function($event){return _vm.onProgramClick(program)}}},[_c('td',[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.helpers.getLocalizedField(program, 'name')))]),_vm._v(" "),_c('td',[(_vm.user.minorProgramID === program.programID)?_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/close.png"}}):_vm._e()])])})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-0 pt-3 mt-sm-5 pt-sm-5 mb-3"},[_c('button',{staticClass:"btn btn-light-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModal()}}},[_vm._v(_vm._s(_vm.$t('registration.close')))])])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groups_modal_vue__ = __webpack_require__(798);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c539d93a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_groups_modal_vue__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groups_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c539d93a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_groups_modal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c539d93a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_groups_modal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"no-close-on-esc":true,"no-close-on-backdrop":true,"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"groups-modal","size":"xl","scrollable":"","centered":""},on:{"shown":function($event){return _vm.onShown()}}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col mb-5 "},[_c('h4',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('registration.choose-group')))]),_vm._v(" "),_c('groups-table',{attrs:{"wants-change":_vm.wantsChange,"already-registered":_vm.alreadyRegistered,"loading":_vm.loading,"subject":_vm.subject,"groups":_vm.groups},on:{"choose":_vm.handleGroupClick}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3"},[_c('button',{staticClass:"btn btn-light-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModal()}}},[_vm._v(_vm._s(_vm.$t('registration.close')))])])])]),_vm._v(" "),_c('practise-groups-modal',{attrs:{"subject":_vm.subject,"seminar":_vm.chosenSeminarGroup,"group":_vm.chosenGroup,"wants-change":_vm.wantsChange,"already-registered":_vm.alreadyRegistered},on:{"register-practise":_vm.choosePractise}}),_vm._v(" "),_c('seminar-groups-modal',{attrs:{"subject":_vm.subject,"group":_vm.chosenGroup,"already-registered":_vm.alreadyRegistered},on:{"open-practise-modal":_vm.openPractiseModalFromSeminar,"register-seminar":_vm.chooseSeminar}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreRegSubjects_vue__ = __webpack_require__(799);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773f10bc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreRegSubjects_vue__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreRegSubjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773f10bc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreRegSubjects_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773f10bc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreRegSubjects_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"no-close-on-esc":true,"no-close-on-backdrop":true,"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"pre-reg-modal","size":"xl","scrollable":"","centered":""},on:{"shown":function($event){return _vm.onShown()}}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col mb-5 "},[_c('h4',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('registration.preRegSubject')))]),_vm._v(" "),_vm._l((_vm.preRegSubjects),function(subject,i){return _c('p',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.handleclick(subject)}}},[_vm._v(" "+_vm._s(subject.subject_code)+" | "+_vm._s(_vm.helpers.getLocalizedField(subject, 'subject'))+" ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3"},[_c('button',{staticClass:"btn btn-light-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModal()}}},[_vm._v(_vm._s(_vm.$t('registration.close')))])])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePreRegSubject_vue__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a36629f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePreRegSubject_vue__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePreRegSubject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a36629f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePreRegSubject_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a36629f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePreRegSubject_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"no-close-on-esc":true,"no-close-on-backdrop":true,"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"change-pre-reg-subject","size":"xl","scrollable":"","centered":""},on:{"shown":function($event){return _vm.onShown()}}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col mb-5 "},_vm._l((Object.keys(_vm.theData)),function(modules,i){return _c('div',[_c('h3',[_vm._v(_vm._s(modules))]),_vm._v(" "),_c('table',{staticClass:"table table-responsive-lg"},_vm._l((_vm.theData[modules]),function(subjects,j){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.changeToSubject(subjects)}}},[_c('td',[_vm._v(" "+_vm._s(subjects.subject_code)+" | "+_vm._s(_vm.helpers.getLocalizedField(subjects, 'subject')))])])}),0)])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3"},[_c('button',{staticClass:"btn btn-light-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModal()}}},[_vm._v(_vm._s(_vm.$t('registration.close')))])])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WriteProblem_vue__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47159522_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteProblem_vue__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WriteProblem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47159522_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteProblem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47159522_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteProblem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"no-close-on-esc":false,"no-close-on-backdrop":false,"hide-header":false,"hide-footer":true,"content-class":"modal-blue","id":"write-problem-modal","size":"xl","scrollable":"","centered":""},on:{"shown":function($event){return _vm.onShown()}}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col mb-5 "},[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('registration.writeProblem')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.problemText),expression:"problemText"}],staticClass:"form-control",staticStyle:{"width":"100%","min-height":"400px"},domProps:{"value":(_vm.problemText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.problemText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3"},[(_vm.showButton)?_c('button',{staticClass:"btn btn-light-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendProblem()}}},[_vm._v(_vm._s(_vm.$t('registration.sendProblem')))]):_vm._e()])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('sidebar'),_vm._v(" "),_c('nav-header'),_vm._v(" "),_c('main',{staticClass:"col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10",attrs:{"role":"main"}},[_c('breadcrumb',{attrs:{"items":_vm.pageData.breadcrumb}}),_vm._v(" "),_c('section',{staticClass:"px-sm-0 mx-sm-0 px-lg-5 mx-lg-5  mt-0 mt-md-5"},[(!_vm.isOpen)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row my-5"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card-primary h-100"},[_c('div',{staticClass:"card-body d-flex align-items-center text-center"},[_c('p',[_vm._v(_vm._s(_vm.$t('registration.registration-closed')))])])])])])]):_c('div',{staticClass:"container-fluid "},[_c('div',{staticClass:"row justify-content-around mb-5 mt-md-5 mt-lg-0 pt-5 pt-sm-0"},[_c('div',{staticClass:"col-sm-6 mb-4 mb-sm-0 "},[_c('div',{staticClass:"card-primary h-100"},[_c('div',{staticClass:"card-body d-flex align-items-center"},[_c('p',[_vm._v(_vm._s(_vm.$t('registration.header-buttons.first-button')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"card-primary"},[_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("\n                      "+_vm._s(_vm.$t('registration.header-buttons.second-button'))+"\n                    ")])])])]),_vm._v(" "),(_vm.showThirdButton())?_c('div',{staticClass:"col-sm-12 mt-4"},[_vm._m(0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-5 mb-5 "},[_c('div',{staticClass:"col text-center mt-5"},[(_vm.guideLink)?_c('h1',{staticClass:"mb-4"},[_c('a',{attrs:{"target":"_blank","href":_vm.guideLink}},[_vm._v(_vm._s(_vm.$t('registration.message-to-students')))])]):_vm._e(),_vm._v(" "),_c('h3',[(!_vm.user.must_choose_english)?_c('my-subjects-modal',{on:{"subject-change":_vm.handleSubjectChange,"subject-remove":_vm.loadModules}}):_vm._e(),_vm._v(" "),(!_vm.user.must_choose_english)?_c('must-change-subjects-modal',{on:{"subject-change":_vm.handleSubjectChange,"subject-remove":_vm.loadModules}}):_vm._e()],1),_vm._v(" "),(_vm.canChooseMinorProgram())?_c('h3',[(!_vm.user.must_choose_english)?_c('minor-programs-modal',{on:{"change":function($event){return _vm.minorProgramChanged($event)}}}):_vm._e()],1):_vm._e()])]),_vm._v(" "),_c('p',{staticClass:"text-center",staticStyle:{"font-size":"20px","cursor":"pointer","font-weight":"bold"},on:{"click":_vm.handleClickPreRegSubjects}},[_vm._v("  "+_vm._s(_vm.$t('registration.preRegSubject')))]),_vm._v(" "),_c('p',{staticClass:"text-center",staticStyle:{"font-size":"20px","cursor":"pointer","font-weight":"bold","color":"red"},on:{"click":function($event){return _vm.writeProblem()}}},[_vm._v(" "+_vm._s(_vm.$t('registration.writeProblem')))]),_vm._v(" "),_c('pre-reg-subjects'),_vm._v(" "),_c('write-problem'),_vm._v(" "),_c('groups-modal',{attrs:{"wants-change":_vm.wantsChange,"subject":_vm.chosenSubject},on:{"changed":_vm.changed,"registered":_vm.loadModules,"closed":_vm.handleModalClose}}),_vm._v(" "),_c('change-pre-reg-subject',{on:{"closed":function($event){return _vm.truncateValue()}}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-start pt-5 pt-sm-0",attrs:{"id":"modules"}},[(_vm.programModules.loading)?_c('sk-cards',{attrs:{"width-class":"col-6","height":0.2,"count":4}}):_vm._l((_vm.programModules.data),function(programModule,i){return _c('div',{staticClass:"col-md-12 col-lg-6 mb-5 px-0 px-sm-4"},[_c('div',{class:['module', { active: _vm.activeCollapses[i] }]},[_c('div',{staticClass:"module-header"},[_c('div',{staticClass:"module-close text-right d-none mb-4 mt-2"},[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('cmodule_' + i),expression:"'cmodule_' + i"}],staticClass:"btn-close",attrs:{"role":"button"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/X.png","alt":""}})])]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('cmodule_' + i),expression:"'cmodule_' + i"}],staticClass:"btn btn-registration",attrs:{"type":"button"}},[_vm._v("\n                      "+_vm._s(_vm.getProgramModuleName(programModule))+"\n                      "),_c('span',{staticClass:"toggle-icon"})])]),_vm._v(" "),_c('b-collapse',{staticClass:"module-body",attrs:{"id":'cmodule_' + i},on:{"shown":function($event){return _vm.loadSubjects(i)}},model:{value:(_vm.activeCollapses[i]),callback:function ($$v) {_vm.$set(_vm.activeCollapses, i, $$v)},expression:"activeCollapses[i]"}},[_c('div',{staticClass:"registration-table"},[(programModule.subjects)?_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('registration.subject')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.evaluation')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.ects')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.semester')))]),_vm._v(" "),_c('th',[_c('span',[_vm._v(" ")])])])]),_vm._v(" "),_c('tbody',[_c('tr',_vm._l((programModule.subjects),function(subjectBlock,blockName){return _c('table',[(blockName !== '-')?_c('tr',{staticClass:"mt-2 mb-1"},[_c('td',{staticClass:"bg-red text-white text-center"},[_vm._v("\n                                "+_vm._s(blockName)+"\n                              ")])]):_vm._e(),_vm._v(" "),_vm._l((subjectBlock),function(subject,s){return (!programModule.concentrationID || subject.concentrationID == programModule.concentrationID)?_c('tr',{on:{"click":function($event){return _vm.check_program_module_restriction(subject)}}},[_c('td',[_vm._v(_vm._s(subject.subject_code)+" - "+_vm._s(_vm.helpers.getLocalizedField(subject, 'subject')))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(subject.Eval)?_c('span',[_vm._v(_vm._s(subject.Eval))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                "+_vm._s(subject.ECTS)+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                "+_vm._s(_vm.helpers.getSubjectSemester(subject.subject_semester))+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.canRemoveTaken(subject))?_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/close.png"}}):(_vm.canTake(subject))?_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/open.png"}}):_vm._e()])]):_vm._e()})],2)}),0)])]):_vm._e()])])],1)])}),_vm._v(" "),(_vm.isVisibleFreeCreditSubjects)?_c('div',{staticClass:"col-md-12 col-lg-6 mb-5 px-0 px-sm-4"},[_c('div',{class:['module', { active: _vm.isActiveFreeCreditSubjects }]},[_c('div',{staticClass:"module-header"},[_c('div',{staticClass:"module-close text-right d-none mb-4 mt-2"},[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('free-credit'),expression:"'free-credit'"}],staticClass:"btn-close",attrs:{"role":"button"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/X.png","alt":""}})])]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('free-credit'),expression:"'free-credit'"}],staticClass:"btn btn-registration",attrs:{"type":"button"}},[_vm._v("\n                      "+_vm._s(_vm.$t('registration.free-credit-subjects'))+"\n                      "),_c('span',{staticClass:"toggle-icon"})])]),_vm._v(" "),_c('b-collapse',{staticClass:"module-body",attrs:{"id":"free-credit"},model:{value:(_vm.isActiveFreeCreditSubjects),callback:function ($$v) {_vm.isActiveFreeCreditSubjects=$$v},expression:"isActiveFreeCreditSubjects"}},[_c('div',{staticClass:"registration-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('registration.subject')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.evaluation')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.ects')))]),_vm._v(" "),_c('th',[_c('span',[_vm._v(" ")])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.freeCreditSubjects),function(subject,s){return _c('tr',{on:{"click":function($event){return _vm.check_program_module_restriction(subject)}}},[_c('td',[_vm._v(_vm._s(subject.subject_code)+" - "+_vm._s(_vm.helpers.getLocalizedField(subject, 'subject')))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(subject.Eval)?_c('span',[_vm._v(_vm._s(subject.Eval))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                            "+_vm._s(subject.ECTS)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.canRemoveTaken(subject))?_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/close.png"}}):(_vm.canTake(subject))?_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/open.png"}}):_vm._e()])])}),0)])])])],1)]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.minorProgramID !== null && _vm.minorSubjects)?_c('div',{staticClass:"col-md-12 col-lg-6 mb-5 px-0 px-sm-4",model:{value:(_vm.isActiveMinorSubjects),callback:function ($$v) {_vm.isActiveMinorSubjects=$$v},expression:"isActiveMinorSubjects"}},[_c('div',{class:['module', { active: _vm.isActiveMinorSubjects }]},[_c('div',{staticClass:"module-header"},[_c('div',{staticClass:"module-close text-right d-none mb-4 mt-2"},[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('minor-subjects'),expression:"'minor-subjects'"}],staticClass:"btn-close",attrs:{"role":"button"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/X.png","alt":""}})])]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('minor-subjects'),expression:"'minor-subjects'"}],staticClass:"btn btn-registration",attrs:{"type":"button"}},[_vm._v("\n                      "+_vm._s(_vm.$t('registration.minor-subjects'))+"\n                      "),_c('span',{staticClass:"toggle-icon"})])]),_vm._v(" "),_c('b-collapse',{staticClass:"module-body",attrs:{"id":"minor-subjects"}},[_c('div',{staticClass:"registration-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('registration.subject')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.evaluation')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.ects')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('registration.semester')))]),_vm._v(" "),_c('th',[_c('span',[_vm._v(" ")])])])]),_vm._v(" "),_c('tbody',[_c('tr',_vm._l((_vm.minorSubjects),function(subjectBlock,blockName){return _c('table',[(blockName !== '-')?_c('tr',{staticClass:"mt-2 mb-1"},[_c('td',{staticClass:"bg-red text-white text-center"},[_vm._v("\n                                "+_vm._s(blockName)+"\n                              ")])]):_vm._e(),_vm._v(" "),_vm._l((subjectBlock),function(subject,s){return _c('tr',{on:{"click":function($event){return _vm.check_program_module_restriction(subject)}}},[_c('td',[_vm._v(_vm._s(subject.subject_code)+" - "+_vm._s(_vm.helpers.getLocalizedField(subject, 'subject')))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(subject.Eval)?_c('span',[_vm._v(_vm._s(subject.Eval))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                "+_vm._s(subject.ECTS)+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                "+_vm._s(_vm.helpers.getSubjectSemester(subject.subject_semester))+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.canRemoveTaken(subject))?_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/close.png"}}):(_vm.canTake(subject))?_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/icons/registrations/open.png"}}):_vm._e()])])})],2)}),0)])])])])],1)]):_vm._e()],2)],1)])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-primary"},[_c('div',{staticClass:"card-body"},[_c('div',[_c('p',[_vm._v("POLI4565 საბაკალავრო ნაშრომის მომზადება")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("POLI4220 საბაკალავრო ნაშრომის მომზადება")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("POLI4228 საბაკალავრო ნაშრომის მომზადება")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("PSYC1426 საბაკალავრო ნაშრომი ფსიქოლოგიაში")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("PSYC1420 საბაკალავრო ნაშრომი ფსიქოლოგიაში")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("JMMB3115 საბოლოო პროექტი ჟურნალისტიკაში")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("JMMB4240 საბოლოო პროექტი ჟურნალისტიკაში")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("COMM5145 საბოლოო პროექტი საზოგადოებასთან ურთიერთობაში")])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("COMM4310 საბოლოო პროექტი საზოგადოებასთან ურთიერთობაში")])]),_vm._v(" "),_c('div',[_c('div',[_c('p',[_vm._v(" ")])]),_vm._v(" "),_c('div',[_c('p',[_c('em',[_vm._v("საგანზე დარეგისტრირება შეუძლიათ მხოლოდ დამამთავრებელ სემესტრზე მყოფ სტუდენტებს.")])])]),_vm._v(" "),_c('div',[_c('p',[_vm._v(" ")])]),_vm._v(" "),_c('div',[_c('p',[_c('em',[_vm._v("იმისათვის, რომ სტუდენტმა დაასრულოს უნივერსიტეტის,  უნდა აკმაყოფილებდეს  პროგრამაში, სწავლების ორგანიზების თავისებურებებში მითითებულ პირობას. ")])])]),_vm._v(" "),_c('div',[_vm._v(" ")])])])])}]


/***/ })

});


// WEBPACK FOOTER //
// static/js/1.d9aecc79c0631db93aa0.js